var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "4" } },
            [
              _c("h2", [_vm._v("Conversations")]),
              _vm._l(_vm.conversations, function (conversation) {
                return _c(
                  "b-card",
                  {
                    key: conversation.id,
                    staticClass: "bg-info text-white fw-bold",
                    on: {
                      click: function ($event) {
                        return _vm.fetchMessages(conversation.id)
                      },
                    },
                  },
                  [
                    _c("b-card-title", [
                      _vm._v(
                        " " +
                          _vm._s(conversation.participants.data[0].name) +
                          " "
                      ),
                    ]),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _c(
            "b-col",
            { attrs: { cols: "8" } },
            [
              _vm.selectedConversationId
                ? [
                    _c("h2", [_vm._v("Messages")]),
                    _c(
                      "b-card",
                      [
                        _vm.loading
                          ? _c("b-spinner", {
                              staticClass: "d-flex justify-content-center",
                              attrs: { label: "Loading..." },
                            })
                          : _vm._e(),
                        _vm._l(_vm.array, function (chat) {
                          return _c(
                            "ul",
                            {
                              key: chat.id,
                              staticClass: "fw-bold text-decoration-none",
                            },
                            [
                              _c("p", { staticClass: "fw-bold" }, [
                                _vm._v("Message : " + _vm._s(chat.message)),
                              ]),
                              _c("p", { staticClass: "fw-bold" }, [
                                _vm._v("From : " + _vm._s(chat.from.name)),
                              ]),
                              _c("p", { staticClass: "fw-bold" }, [
                                _vm._v(
                                  "Date : " +
                                    _vm._s(
                                      _vm.convertToLocalTime(chat.created_time)
                                    )
                                ),
                              ]),
                            ]
                          )
                        }),
                        _c("b-dropdown-divider"),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }